const Types = {
    Message: 'message',
    Thread: 'thread',
    Company: 'company',
    User: 'user',
    UserBox: 'userBox'
};
export default Types;